import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';
import { useConfig } from '@/contexts/ConfigContext';
import { useInstanceId } from '@/contexts/InstanceIdContext';
import { useStandaloneAuthentication } from '@/hooks/authentication/useStandaloneAuthentication';

export function useClientAuthenticationHandler() {
  const { IFRAME_URL } = useConfig();
  const navigate = useNavigate();
  const { instanceId } = useInstanceId();
  const { refreshAuthentication } = useStandaloneAuthentication();

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== IFRAME_URL) {
        return;
      }

      if (event?.data?.source !== 'antimatter-client') {
        return;
      }

      if (event?.data?.error === 401) {
        refreshAuthentication().catch((refreshError) => {
          datadogRum.addError(refreshError);
          console.error('Failed to refresh authentication:', refreshError);
        });
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [IFRAME_URL, instanceId, navigate, refreshAuthentication]);
}
